export enum SuperAdminMenuType {
    CRAWLERS = 'base.backend_admin.crawlers',
    WORKER_QUEUE = 'base.backend_admin.workerqueue',
    ACCESSIBILITY_CHECKS = 'base.backend_admin.admin.accessibility_checks',
    DATA_PRIVACY_CHECKS = 'base.backend_admin.admin.data_privacy_checks',
    COOKIE_REPO = 'base.backend_admin.admin.cookies.repo',
    SEARCH_USER = 'base.backend_admin.support.users-search',
    DELETE_USERS = 'base.backend_admin.admin.users-delete',

}
